var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.dispalyViewer,
          expression: "dispalyViewer"
        }
      ],
      style: _vm.maskContainer,
      on: {
        mouseover: function($event) {
          return _vm.eleShow()
        },
        mouseleave: function($event) {
          return _vm.eleHide()
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEle == true,
              expression: "showEle==true"
            }
          ],
          staticClass: "imgName"
        },
        [
          _c("span", { staticClass: "center" }, [
            _vm._v(_vm._s(_vm.bigImgName))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "closeBtn", on: { click: _vm.closeViewer } },
            [_c("i", { staticClass: "iconfont icon-guanbi" })]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEle == true,
              expression: "showEle==true"
            }
          ],
          staticClass: "leftArrowCon",
          on: { click: _vm.handlePrev }
        },
        [_c("span", { staticClass: "leftArrow" }, [_vm._v("《")])]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "imgContainer",
          staticClass: "imgContainer",
          style: _vm.imgContainer
        },
        [
          _c("img", {
            ref: "bigImg",
            style: _vm.bigImg,
            attrs: { src: _vm.bigImgUrl, alt: "", width: "96%", height: "96%" }
          }),
          _vm._v(" "),
          _c(
            "transition",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showEle == true,
                  expression: "showEle==true"
                }
              ],
              attrs: { name: "fade" }
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showTips,
                      expression: "showTips"
                    }
                  ],
                  staticClass: "tips"
                },
                [_vm._v(_vm._s(_vm.tipsText))]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEle == true,
              expression: "showEle==true"
            }
          ],
          staticClass: "rightArrowCon",
          on: { click: _vm.handleNext }
        },
        [_c("span", { staticClass: "rightArrow" }, [_vm._v("》")])]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEle == true,
              expression: "showEle==true"
            }
          ],
          staticClass: "fixedHandle"
        },
        [
          _c(
            "div",
            {
              staticClass: "handleContainer cancelselect",
              attrs: { onselectstart: "return false" }
            },
            [
              _c("ul", [
                _c("li", { on: { click: _vm.enlarge } }, [
                  _c("i", { staticClass: "iconfont icon-fangda" })
                ]),
                _vm._v(" "),
                _c("li", { on: { click: _vm.reduce } }, [
                  _c("i", { staticClass: "iconfont icon-unie039" })
                ]),
                _vm._v(" "),
                _c("li", { on: { click: _vm.rotate } }, [
                  _c("i", { staticClass: "iconfont icon-xuanzhuan" })
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _vm.displayThumbnailContainer
            ? _c("div", { staticClass: "thumbnailContainer" }, [
                _c(
                  "ul",
                  _vm._l(this.imgData, function(item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        on: {
                          click: function($event) {
                            return _vm.switchImgUrl(index)
                          }
                        }
                      },
                      [_c("img", { attrs: { src: item.url, alt: "" } })]
                    )
                  }),
                  0
                )
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e2dcdc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e2dcdc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/vue-picture-viewer.vue
// module id = null
// module chunks = 